<template>
  <van-popup :show="show" @update:show="(val: boolean) => emit('update:show', val)" round
    :position="isLargeScreen === false ? 'bottom' : 'center'" closeable close-icon-position="top-right"
    safe-area-inset-top safe-area-inset-bottom :close-on-click-overlay="closeOnClickOverlay" class="popup-container"
    teleport="body" :class="`
    ${widthFitContent ? 'fit' : ''}
    ${circleClose ? 'circleClose' : ''}
    ${fullScreen ? 'fullScreen' : ''}
    ${isSafari === true ? 'safari' : ''}
    ${isMobile === true ? 'mobile' : ''}
    `" overlay-class="overlay">
    <div v-if="$slots?.title" class="title">
      <slot name="title" />
    </div>
    <slot />
  </van-popup>
</template>
<script setup lang="ts">
import { Popup as VanPopup } from "vant";
import useDevice from "./useDevice";

interface Props {
  show?: boolean;
  closeOnClickOverlay?: boolean;
  widthFitContent?: boolean;
  circleClose?: boolean;
  fullScreen?: boolean;
}

type Event = {
  (e: "update:show", show: boolean): void;
};

const { isSafari, isMobile } = useDevice();

const props = withDefaults(defineProps<Props>(), {
  closeOnClickOverlay: false,
});

watch(
  () => props.show,
  (visible) => {
    emit("update:show", visible);
  },
);

const emit = defineEmits<Event>();

// const { isLargeScreen } = useDevice();

const isLargeScreen = ref(false);
const resize = () => {
  isLargeScreen.value = window.innerWidth >= 1360;
};
onMounted(() => {
  resize();
});
window.addEventListener("resize", resize);
window.addEventListener("orientationchange", resize);

onBeforeUnmount(() => {
  window.removeEventListener("resize", resize);
  window.removeEventListener("orientationchange", resize);
})
</script>

<style scoped lang="less">
.popup-container {
  padding-bottom: var(--safe-area-bottom);
  --kling-modal-background: rgba(26, 27, 34, 1);
  width: 11.2rem;
  border-radius: 0.32rem;
  border-width: 0.02rem;
  border-color: rgba(255, 255, 255, 0.06);
  background-color: rgba(26, 27, 34, 1);
  font-size: 0.3rem;
  padding-top: 0;
  color: #fff;

  &.fit {
    width: fit-content;
  }

  :deep(.van-popup) {
    &__close-icon {
      color: rgba(255, 255, 255, 0.3);
      font-size: 0.56rem;
      font-weight: 500;

      @media screen and (max-width: 1360px) {
        font-size: 0.4rem;
        // margin-top: var(--safe-area-top);
      }
    }
  }

  &.fullScreen {
    padding-top: var(--safe-area-top);

    :deep(.van-popup) {
      &__close-icon {
        @media screen and (max-width: 1360px) {
          margin-top: var(--safe-area-top);
        }
      }
    }
  }

  &.circleClose {
    :deep(.van-popup) {
      &__close-icon {
        top: 0.45rem;
        right: 0.4rem;
        background: rgba(34, 34, 34, 0.4);
        border: 0.0068rem solid rgba(255, 255, 255, 0.08);
        border: 0.0068rem solid rgba(255, 255, 255, 0.08);
        padding: 0.27rem;
        border-radius: 50%;
        font-size: 0.36rem;
        color: rgba(255, 255, 255, 0.8);
        @media screen and (max-width: 1360px) {
          top: 0.7rem;
          right: 0.24rem;
          background: rgba(34, 34, 34, 0.5);
          border: 0.0068rem solid rgba(255, 255, 255, 0.1);
          padding: 0.12rem;
          color: rgba(255, 255, 255, 0.7);
          border-radius: 50%;
          font-size: 0.21rem;
        }
      }
    }
  }

  .title {
    width: 100%;
    height: 1.44rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.48rem;
    font-weight: 500;
    color: #fff;
    line-height: 1em;
    border-bottom: 0.01rem solid rgba(255, 255, 255, 0.06);
  }

  --van-popup-close-icon-size: 0.56rem; // 关闭按钮大小
  --van-popup-close-icon-margin: 0.32rem; // 关闭按钮距离

  @media screen and (max-width: 1360px) {
    width: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    .title {
      height: 1.04rem;
      font-size: 0.3rem;
      font-weight: 500;
      color: #fff;
    }

    --van-popup-close-icon-size: 0.4rem; // 关闭按钮大小
  }
}

.overlay {
  background-color: rgba(0, 0, 0, 0.8);
}
</style>
